import(/* webpackMode: "eager" */ "/app/src/app/language/page.tsx");
